// Articles / blog. Phase 1: two existing external articles rendered as linked entries.
// slug fields are kept for future in-house articles and route parity.
export const articles = [
  {
    slug: { el: "epiliptiki-krisi-i-epilipsia", en: "seizure-or-epilepsy" },
    external: true,
    url: "https://www.ygeiamou.gr/blogs/opios-kani-epiliptiki-krisi-echi-epilipsia-i-nevrologos-exigi-ti-diafora/",
    source: "ygeiamou.gr",
    date: "2024",
    title: {
      el: "Όποιος κάνει επιληπτική κρίση έχει επιληψία; Η νευρολόγος εξηγεί τη διαφορά",
      en: "Does everyone who has a seizure have epilepsy? The neurologist explains the difference",
    },
    excerpt: {
      el: "Μια μεμονωμένη επιληπτική κρίση δεν σημαίνει πάντα επιληψία. Πότε πρόκειται για παροδικό επεισόδιο και πότε χρειάζεται περαιτέρω διερεύνηση.",
      en: "A single seizure does not always mean epilepsy. When it is a transient episode and when further investigation is needed.",
    },
  },
  {
    slug: { el: "burnout-nevrologiki-prosengisi", en: "burnout-neurological-view" },
    external: true,
    url: "/api/articles/burnout.pdf",
    source: "ΕΡΜΗΣ (Νο. 95)",
    date: "2026",
    title: {
      el: "Επαγγελματική εξουθένωση (burnout): μια νευρολογική ματιά",
      en: "Professional burnout: a neurological perspective",
    },
    excerpt: {
      el: "Πώς το χρόνιο στρες επηρεάζει το νευρικό σύστημα και τι μπορούμε να κάνουμε για την πρόληψη και τη διαχείρισή του.",
      en: "How chronic stress affects the nervous system and what can be done for its prevention and management.",
    },
  },
];
